import React, { useEffect, useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import toast from 'react-hot-toast'
import { UserApi } from 'mvppoker-portal-common/api'
import { createMVPModal } from '../Modal'
import { store } from '../../../state/AppStore'
import { setDepositBonus } from '../../../state/reducers/ProfileDataReducer'
import { useApi } from '../../../utils/useApi'
import { useDepositBonus } from '../../../state/hooks/ProfileDataHooks'
import { WalletDepositBonusModalView } from './WalletDepositBonusModalView'

class WalletDepositBonusModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('wallet-deposit-bonus-modal', () =>
		{
			const modal = useModal()
			const userApi = useApi(UserApi)
			const [isClaiming, setClaiming] = useState(false)
			const depositBonus = useDepositBonus()!

			useEffect(() => {
				if (!depositBonus.seen){
					userApi.usersDepositBonusMarkSeen()
					.then((b) => {
						if (b.data){
							store.dispatch(setDepositBonus(b.data))
						}
					})
				}
			}, [])
		
			const clickClaim = () => {
				setClaiming(true)
		
				// Alert.Wait(message=R.string.walletdepositbonus_wait.localised()) { alert ->
		
				userApi.usersDepositBonusClaim()
				.then((b) => {
					store.dispatch(setDepositBonus(b.data))
				}).finally(() => {
					if (depositBonus.claimed){
						modal.hide()
						return
					}
					toast.success('Well Done! You\'ve claimed your bonus!')
				})
			}

			return <div> </div>
			// return <WalletDepositBonusModalView 
			// 	depositBonus={depositBonus}
			// 	isClaiming={isClaiming}

			// 	clickClaim={clickClaim}
			// />
		}))
	}
}

const modal = new WalletDepositBonusModal()
export default modal